import TachycardiaChart from "../../../../src/client/examples/json/tachycardia.json";
import * as React from 'react';
export default {
  TachycardiaChart,
  React
};